import {OPEN_MODAL, OPEN_FRAME, OPEN_MODAL_VIDEO, OPEN_MODAL_DIALOG, OPEN_POPUP_LOCATE_CITY, OPEN_SUBSCRIPTION_STATUS} from './actionTypes'

const initialState = {
  modalStatus: 0,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case `${OPEN_MODAL}`:
      return {
        ...state,
        modalStatus: action.open,
      }

    default:
      return state
  }
}

const initState = {
  frameStatus: 0,
}

export const FrameReducer = (state = initState, action) => {
  switch (action.type) {
    case `${OPEN_FRAME}`:
      return {
        ...state,
        frameStatus: action.open,
      }

    default:
      return state
  }
}

const initSt = {
  videoStatus: false,
}

export const ModalVideoReducer = (state = initSt, action) => {
  switch (action.type) {
    case `${OPEN_MODAL_VIDEO}`:
      return {
        ...state,
        videoStatus: action.payload,
      }

    default:
      return state
  }
}

const initDialog = {
  dialogStatus: false,
}

export const ModalDialogReducer = (state = initDialog, action) => {
  switch (action.type) {
    case `${OPEN_MODAL_DIALOG}`:
      return {
        ...state,
        dialogStatus: action.payload,
      }

    default:
      return state
  }
}

const initLocateCity = {
  locateCityStatus: false,
}

export const PopupLocateCityReducer = (state = initLocateCity, action) => {
  switch (action.type) {
    case `${OPEN_POPUP_LOCATE_CITY}`:
      return {
        ...state,
        locateCityStatus: action.payload,
      }

    default:
      return state
  }
}

const initSubscription = {
  subscriptionStatus: false,
}

export const SubscriptionStatusReducer = (state = initSubscription, action) => {
  switch (action.type) {
    case OPEN_SUBSCRIPTION_STATUS:
      return {
        ...state,
        subscriptionStatus: action.payload,
      }

    default:
      return state
  }
}